"use strict";
angular.module("setLocationModule", [])
    .controller("setLocationCtrl", ["$scope", "$modalInstance", "$q", "$timeout", "assignmentAddress", function($scope, $modalInstance, $q, $timeout, assignmentAddress) {
        loadBMap().then(function() {
            initMap();
        });

        function loadBMap() {
            var deffer = $q.defer();
            window.HOST_TYPE = "2";
            window.BMap_loadScriptTime = (new Date).getTime();
            LazyLoad.js(["https://api.map.baidu.com/getscript?v=2.0&ak=2OWwHzlWU6jNhRGfjIUZFx7UBZnqgGYl&services=&t=20190123111209"], function() {
                deffer.resolve();
            });
            return deffer.promise;
        };
        /**
         * [initMap description] 初始化地图
         * @return {[type]} [description]
         */
        function initMap() {
            $scope.mapContainer = new BMap.Map("map-container");
            $scope.mapContainer.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
            $scope.mapContainer.addControl(new BMap.MapTypeControl()); //添加地图类型控件
            $scope.geoc = new BMap.Geocoder();
            $scope.assignmentAddress = angular.copy(assignmentAddress);
            if (angular.isDefined($scope.assignmentAddress.value)) {
                var point = new BMap.Point($scope.assignmentAddress.value.lng, $scope.assignmentAddress.value.lat);
                var marker = new BMap.Marker(point);
                $scope.mapContainer.addOverlay(marker);
                $scope.mapContainer.centerAndZoom(point, 19);
                getArrdess(point);
            } else {
                $scope.mapContainer.centerAndZoom("乌鲁木齐", 12);
                $scope.assignmentAddress = { "name": "", "value": { "lng": 0, "lat": 0 } };
            }
            $scope.autoComp = new BMap.Autocomplete({
                "input": "suggest-inp",
                "location": $scope.mapContainer
            });
            $scope.autoComp.setInputValue($scope.assignmentAddress.name);
            //搜索结果绑定hover事件
            $scope.autoComp.addEventListener("onhighlight", function(e) {
                var str = "",
                    _value, value;
                if (e.fromitem.index > -1) {
                    _value = e.fromitem.value;
                    value = _value.province + _value.city + _value.district + _value.street + _value.business;
                }
                str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;
                if (e.toitem.index > -1) {
                    _value = e.toitem.value;
                    value = _value.province + _value.city + _value.district + _value.street + _value.business;
                }
                str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
                $("#searchResultPanel").html(str);
            });
            //搜索结果绑定点击事件
            $scope.autoComp.addEventListener("onconfirm", function(e) {
                var _value = e.item.value;
                var myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
                var str = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
                $("#searchResultPanel").html(str);
                $scope.assignmentAddress.name = myValue;
                $scope.hiddenSuggestion();
                setPlace(myValue);
            });
            /**
             * [description] 绑定地图点击事件
             * @param  {[type]} e) {                           console.log(e);            } [description]
             * @return {[type]}    [description]
             */
            $scope.mapContainer.addEventListener("click", function(e) {
                getArrdess(e.point).then((result) => {
                    $scope.assignmentAddress.name = result.address;
                    $scope.assignmentAddress.value.lng = result.point.lng;
                    $scope.assignmentAddress.value.lat = result.point.lat;
                });
            });
        }
        /**
         * [setPlace description] 搜索结果
         * @param myValue
         */
        function setPlace(myValue) {
            $scope.mapContainer.clearOverlays(); //清除地图上所有覆盖物
            function myFun() {
                var pp = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
                $scope.mapContainer.centerAndZoom(pp, 18);
                $scope.mapContainer.addOverlay(new BMap.Marker(pp)); //添加标注
                $scope.assignmentAddress.value = pp;
                getArrdess(pp);
            }
            var local = new BMap.LocalSearch($scope.mapContainer, { //智能搜索
                onSearchComplete: myFun
            });
            local.search(myValue);
        }
        /**
         * [getArrdess description] 根据经纬度进行逆地址解析
         * @param  {[type]} point [description] 经纬度坐标
         * @return {[type]}       [description]
         */
        function getArrdess(point) {
            let defer = $q.defer();
            $scope.geoc.getLocation(point, function(rs) {
                var addComp = rs.addressComponents;
                $("#task_address_result").html(addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber);
                defer.resolve(rs);
            });
            return defer.promise;
        }
        /**
         * [searchAddressData description] 点击按钮搜索
         * @return {[type]} [description]
         */
        $scope.searchAddressData = function() {
            setPlace($scope.assignmentAddress.name);
        };
        /**
         * [setSearchContent description] 搜索结果内容
         * @return {[type]} [description]
         */
        $scope.setSearchContent = function() {
            var suggestInitHtmlContent = $("body").find(".tangram-suggestion-main").html();
            $(".search-address-b").find("#search-result-cont").html(suggestInitHtmlContent);
        };
        /**
         * [hiddenSuggestion description] 隐藏搜索结果
         * @return {[type]} [description]
         */
        $scope.hiddenSuggestion = function() {
            $(".search-address-b").find("#search-result-cont").html("");
        };
        /**
         * [cancel description] 弹窗关闭
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $scope.autoComp.dispose();
            $modalInstance.dismiss();
        }
        /**
         * [confirm description] 确定
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $scope.autoComp.dispose();
            if ($scope.assignmentAddress.name == "" && $scope.assignmentAddress.value.lng == 0 && $scope.assignmentAddress.value.lat == 0) {
                $modalInstance.close("");
            } else {
                $modalInstance.close($scope.assignmentAddress);
            }

        }
        /**
         * [clear description] 清空地图选中位置
         * @return {[type]} [description]
         */
        $scope.clear = function(){
            $scope.assignmentAddress.name = "";
            $scope.assignmentAddress.value.lat = 0;
            $scope.assignmentAddress.value.lng = 0;
            $("#task_address_result").html("");
        }
    }]);